import { createSlice } from "@reduxjs/toolkit";

export const profileSlice = createSlice({
  name: "profileReducer",
  initialState: {},
  reducers: {},
});

export default profileSlice.reducer;
